import { gql } from '@apollo/client';

const Fragments = {
    financialProductWarrantyEditItem: gql`
    fragment financialProductWarrantyEditItem on FinancialProductWarrantyEditItem {
        leasingFinancialProductXWarrantyId
        productId
        warrantyTypeId
        warrantyTypeName
        quantity
        quantityTypeId
        quantityTypeName
        mandatory
        genericFilterTemplateId
        templateName
    }
  `
};

export default Fragments;
